import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var auditReportViewTimeRes;
export const auditReportViewTimeTodo = createAsyncThunk('auditReportViewTime', async (id) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'check_audit_report_time',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "audit_report_id": id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return auditReportViewTimeRes = res.data
    } catch (error) {
        return auditReportViewTimeRes = error.response.data
    }
})